defineDs('DanskeSpil/Domain/Feature.Components/Scripts/SeriePodcast.js',
  [
    'Common/Framework/Foundation.SharedScripts/Scripts/Libraries/CustomSlider',
    'Shared/Framework/Ensighten/Scripts/ComponentTracking'
  ], function (CustomSlider, ComponentTracking) {
    const series = document.querySelectorAll('.js-serie-podcast');

    if (series) {
      series.forEach((serieElement) => {
        const id = serieElement.querySelector('.serie-podcast-slider-selector').getAttribute('id');

        const slider = new CustomSlider({
          containerSelector: '#' + id,
          controls: {
            enabled: true,
            next: `.${id}-slider-next`,
            previous: `.${id}-slider-previous`,
            disabledClasses: ['!opacity-0', '!pointer-events-none']
          },
          elementClasses: {
            general: ['w-full', 'shrink-0', 'transition-opacity', 'duration-500', 'ease-in-out', 'opacity-100'],
            passive: ['pointer-events-none', '@672:animate-seriesSlideFadeOut'],
            active: ['@672:animate-seriesSlideFadeIn'],
          },
          settings: {
            center: true,
            enableMouseDrag: false,
            slideBy: 1,
            maxGroupSize: 1,
          }
        });

        const controls = serieElement.querySelectorAll(`.${id}-slider-next, .${id}-slider-previous`);
        let userInitiatedSlide = false;
        let slideInteraction = '';
        controls.forEach((control) => control.addEventListener('click', () => {
          userInitiatedSlide = true;
          slideInteraction = control.classList.contains(`${id}-slider-next`) ? 'next' : 'previous';
          setTimeout(() => {
            userInitiatedSlide = false;
            slideInteraction = '';
          }, 0);
        }, true));
        serieElement.addEventListener('touchstart', () => {
          userInitiatedSlide = true;
          slideInteraction = 'swipe';
        }, { passive: true });

        // Update slider indicators
        const indicatorsDesktop = document.querySelectorAll(`#${id}-slider-indicators-desktop > div`);
        const indicatorsMobile = document.querySelectorAll(`#${id}-slider-indicators-mobile > div`);
        const updateIndicator = (activeIndicator = 0) => {
          indicatorsDesktop.forEach((indicator, i) => {
            indicator.setAttribute('data-active', `${i === activeIndicator}`);
          });
          indicatorsMobile.forEach((indicator, i) => {
            indicator.setAttribute('data-active', `${i === activeIndicator}`);
          });
        };
        updateIndicator();

        // Update slider images
        const updateImage = (indices = 0) => {
          const images = document.querySelectorAll(`#${id}-slider-images > img`);
          images.forEach((image, i) => {
            if (i < indices) image.setAttribute('data-image', 'prev');
            else if (i > indices) image.setAttribute('data-image', 'next');
            else image.setAttribute('data-image', 'current');
          });
        };
        updateImage();

        // update indicator, image and background on change slide
        slider.onSlideCallback = (indices) => {
          let activeIndicator;
          if (indices.includes(0)) activeIndicator = 0;
          else if (indices.includes(slider._slides.length - 1)) activeIndicator = 2;
          else activeIndicator = 1;

          updateIndicator(activeIndicator);
          updateImage(indices[0]);

          if (userInitiatedSlide) {
            const podcast = slider._slides[indices[0]];
            ComponentTracking.trackNavigationClick({
              name: podcast?.dataset.podcastTitle,
              text: slideInteraction,
              position: indices[0] + 1,
              placement: 'serie_podcast',
              type: 'slider',
              category: 'podcast'
            });
            userInitiatedSlide = false;
            slideInteraction = '';
          }
        };

        // update indicator, image and background on resize
        window.addEventListener('resize', () => {
          handleSliderControls(serieElement);
        });

        handleSliderControls(serieElement);
      });
    }
    function isDeviceTouchable() {
      return (('ontouchstart' in window) ||
        // eslint-disable-next-line compat/compat
        (navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints > 0));
    }

    function handleSliderControls(element) {
      element.closest('.group').classList.toggle('js-force-show-controls', !isDeviceTouchable());
    }
  });
